// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"4be09b09","204":"4554a0e5","273":"985aec18","661":"c1e07cb8","982":"49a12756"}[chunkId] + ".css";
};